import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse'
import { gsap } from "gsap";
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';




// Components
/* The following plugins are Club GSAP perks */
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";


gsap.registerPlugin(ScrollTrigger, ScrollSmoother, DrawSVGPlugin);

let smoother = ScrollSmoother.create({
    smooth: 2, // how long (in seconds) it takes to "catch up" to the native scroll position
    effects: true, // looks for data-speed and data-lag attributes on elements
    smoothTouch: 0.3, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
});

let mm = gsap.matchMedia();

//draws all elements with the "draw-me" class applied 
// gsap.from(".draw-me", {duration:1,drawSVG: 0});


// Side Scroll Pin Section

const sideScrollPinSections = document.querySelectorAll('.side-scroll-pin-section')
const sideScrollPins = document.querySelectorAll('.side-scroll-pin')
const slideGroups = document.querySelectorAll(".slide-group")
const slideTexts = document.querySelectorAll(".slide-text")
const stillTexts = document.querySelectorAll(".still-text")
const slideVideos = document.querySelectorAll(".slide-video")

if(sideScrollPinSections.length) {
    for (let i = 0; i < sideScrollPinSections.length; i++) {
        const section = sideScrollPinSections[i];
        const slideGroup = slideGroups[i];
        const slideText = slideTexts[i];
        const stillText = stillTexts[i];
        const slideVideo = slideVideos[i];
        
        mm.add("(min-width: 768px)", () => {
            const sideScrollPinTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    start: "top top",
                    scrub: true,
                    end: window.innerHeight*3,
                    pin: true,
                    markers: false
                },
            })
    
            // gsap.set(slideText, {x: -slideTextWidth})
    
            sideScrollPinTimeline
            .addLabel("start")
            .to(slideGroup, {x: -(window.innerWidth + (window.innerWidth * .75)), duration: 1, ease: "none"})
            .to(slideText, {x: -((window.innerWidth + (window.innerWidth * .75)) * .15), duration: .15, ease: "none"}, '<85%')
            .to(stillText, {opacity: 0, duration: .3},'start+=0.2')
            .to(slideText, {opacity: 1, duration: .3},'start+=0.7')

        })
        
        
    }
}


// SwiperJS
const homeSwiper = new Swiper('.two-col-entries-swiper', {
    modules: [Pagination],
    direction: 'horizontal',
    spaceBetween: 30,
    pagination: {
      el: '.two-col-entries-swiper-pagination',
      clickable: true,
    },
});

const slideEntryTexts = document.querySelectorAll(".slide-entry-text")

homeSwiper.on('slideChange', function (e) {

    if(slideEntryTexts){
        for (let i = 0; i < slideEntryTexts.length; i++) {
            const el = slideEntryTexts[i];
            let index = parseInt(getSlideNumber(el.id))
            if(index === e.activeIndex){
                el.classList.add("slide-entry-text-active")
                gsap.fromTo(el, {alpha: 0}, {alpha: 1, duration: .3})
            }else{
                el.classList.remove("slide-entry-text-active")
            }
        }
    }

});

function getSlideNumber(str) {
    return str.split('slide-entry-text-')[1];
}


// Marquee
function Marquee(selector, speed) {
    const parentSelector = document.querySelector(selector);
    if(parentSelector) {
        const clone = parentSelector.innerHTML;
        const firstElement = parentSelector.children[0];
        let i = 0;
        parentSelector.insertAdjacentHTML('beforeend', clone);
        parentSelector.insertAdjacentHTML('beforeend', clone);
    
        setInterval(function () {
        firstElement.style.marginLeft = `-${i}px`;
        if (i > firstElement.clientWidth) {
            i = 0;
        }
        i = i + speed;
        }, 0);
    }
  }
  
  //after window is completed load
  //1 class selector for marquee
  //2 marquee speed 0.2
  window.addEventListener('load',Marquee('.marquee', 0.2))



// Line Animations
const linesWrapper = document.querySelector(".lines-wrapper")
const desktopGrid = document.querySelector(".desktop-grid")
const mobileGrid = document.querySelector(".mobile-grid")

if(linesWrapper){
    if(desktopGrid){
        const lineTl = gsap.timeline({
            scrollTrigger: {
                trigger: ".lines-wrapper",
                scrub: true,
                start: "top bottom",
                end: "bottom top-=500"
              }
        })
        
        lineTl
        .from("#line-01", {drawSVG:0})
        .from("#line-02", {drawSVG:0})
        .from("#line-03", {drawSVG:0})
        .from("#line-04", {drawSVG:0})
        .from("#line-05", {drawSVG:0})
        .from("#line-06", {drawSVG:0})
        .from("#line-07", {drawSVG:0})
        .from("#line-08", {drawSVG:0})
        .from("#line-09", {drawSVG:0})
        .from("#line-10", {drawSVG:0})
    }

    if(mobileGrid){
        const mobileLineTl = gsap.timeline({
            scrollTrigger: {
                trigger: ".lines-wrapper",
                scrub: true,
                start: "top bottom",
                end: "bottom top-=300"
              }
        })
        
        mobileLineTl
        .from("#m-line-01", {drawSVG:0}, ".2")
        .from("#m-line-02", {drawSVG:0})
        .from("#m-line-03", {drawSVG:0})
        .from("#m-line-04", {drawSVG:0})
        .from("#m-line-05", {drawSVG:0})
 
    }
    

    const lineImgs = document.querySelectorAll('.line-img')
    
    if(lineImgs.length) {
        for (let i = 0; i < lineImgs.length; i++) {
            const el = lineImgs[i];
            gsap.to(el,{
                scrollTrigger: {
                    trigger: el,
                    start: 'top bottom',
                    end: 'top 25%',
                    scrub: 0.5
                },
                ease: "none",
                opacity: 1
            });
        }
       
    }
}

// What We Do Navigation Desktop
gsap.utils.toArray(".what-we-do-nav a").forEach(function (button, i) {
    button.addEventListener("click", (e) => {
    var id = e.target.getAttribute("href");
    //console.log(id);
    smoother.scrollTo(id, true, "top top");
    e.preventDefault();
    });
});

// General ScrollSmoother anchor functionality
window.onload = (event) => {

    let urlHash = window.location.href.split("#")[1];
    let scrollElem = document.querySelector("#" + urlHash);

    if (urlHash && scrollElem) {
        gsap.to(smoother, {
        scrollTop: smoother.offset(scrollElem, "top top")
        });
    }
};
  


// Timeline Swiper

let timelineSwiper = new Swiper('.timeline-swiper', {
    modules: [Pagination, Navigation],
    direction: 'horizontal',
    spaceBetween: 20,
    slidesPerView: 1,
    centeredSlides: true,
    navigation: {
      prevEl: ".timeline-prev",
      nextEl: ".timeline-next"
    },
    breakpoints: {
        640: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1.3,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 50,
        },
    }
});
htmx.on('htmx:afterSwap', function(event) {
    timelineSwiper.destroy()
})

htmx.on('htmx:afterSettle', function(event) {
    
    
    let timelineSwiper = new Swiper('.timeline-swiper', {
        modules: [Pagination, Navigation],
        direction: 'horizontal',
        spaceBetween: 20,
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        navigation: {
          prevEl: ".timeline-prev",
          nextEl: ".timeline-next"
        },
        breakpoints: {
            640: {
              slidesPerView: 1.2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 1.3,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 50,
            },
        }
    });
})


// Full Width Swiper
let fullWidthSwiper = new Swiper('.full-width-swiper', {
    modules: [Navigation, Autoplay],
    direction: 'horizontal',
    spaceBetween: 20,
    slidesPerView: 1.2,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
    centeredSlides: false,
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: true,
    },

    navigation: {
      prevEl: ".full-width-swiper-prev",
      nextEl: ".full-width-swiper-next"
    },
    breakpoints: {
        640: {
          slidesPerView: 1.3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.1,
          spaceBetween: 40,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
        },
        1024: {
          slidesPerView: 2.5,
          spaceBetween: 50,
          slidesOffsetBefore: 40,
          slidesOffsetAfter: 40,
        },
        1280: {
            slidesPerView: 2.5,
            spaceBetween: 50,
            slidesOffsetBefore: 80,
            slidesOffsetAfter: 80,
          },
    }
});

// Navigation
const navButton = document.getElementById("nav-button")
const navClose = document.getElementById("nav-close")
const nav = document.getElementById("navigation")

if(nav && navClose && navButton){
    navButton.addEventListener("click", () => {
        nav.classList.remove("translate-x-full")
    })
    navClose.addEventListener("click", () => {
        nav.classList.add("translate-x-full")
    })
}


// Additional Team Member Image Swapper
const additionalImages = document.querySelectorAll(".additional-team-image")


if(additionalImages.length){
    let count = 0

    const changeImage = () => {
        // console.log(count)
        for (let i = 0; i < additionalImages.length; i++) {
            const el = additionalImages[i];
            if(i === count ){
                el.classList.remove("hidden")
            } else {
                el.classList.add("hidden")
            }
        }
        if(count === additionalImages.length) {
            count = 0
        } else {
            count = count + 1
        } 
    }
    setInterval(changeImage, 500);
}




// Global
window.Alpine = Alpine;
Alpine.plugin(collapse)

// Inits
Alpine.start();